import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Card from "../Components/Card";
import Button from "../Components/Button";

const Unauthorized = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from;

  return (
    <div className="max-w-3xl mx-auto w-full">
      <Card
        header={<div className="flex items-center justify-between w-full">Unauthorized</div>}
      >
        <div className="space-y-4">
          <p className="text-slate-700">
            You don&apos;t have permission to access this page.
          </p>
          {from ? (
            <p className="text-sm text-slate-500">
              Requested path: <span className="font-mono">{from}</span>
            </p>
          ) : null}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button variant="primary" onClick={() => navigate(-1)}>
              Go back
            </Button>
            <Button variant="secondary" onClick={() => navigate("/")}>
              Go to home
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Unauthorized;

